import React from 'react'

const IMG_BASE64 = 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAACAkQBADs='

/**
 * @param isWebpEnabled
 * @param srcSet
 * @param alt
 * @param imgStyle
 * @param className
 * @param onError
 * @param isLazyLoading
 * @returns {JSX.Element}
 * @constructor
 */
export function ImageImg ({
  isWebpEnabled,
  srcSet,
  alt,
  imgStyle,
  className,
  onError,
  isLazyLoading
}) {
  const imgSrcSet = srcSet

  const props = {
    alt,
    style: imgStyle,
    className,
    onError,
    fetchpriority: 'high'
  }

  if (isLazyLoading) {
    // props['data-low-src'] = dataLowSrc
    // props.src = dataLowSrc
    props.src = IMG_BASE64
    props['data-srcset'] = imgSrcSet
    props['data-sizes'] = 'auto'
    props.fetchpriority = 'low'
  } else if (isWebpEnabled) {
    props.srcSet = imgSrcSet
    // props.src = dataLowSrc
    props.src = IMG_BASE64
  } else {
    props.srcSet = imgSrcSet
  }

  return <img {...props} />
}
